import type { AdapterMeta } from "@repo/adapter-core";

export const BUXTON_META: AdapterMeta = {
  slug: "buxton",
  name: "Buxton",
  baseUrl: "https://buxton.com.au",
  description: "Agency network across Melbourne's bayside and south-eastern suburbs.",
  supportedStates: ["VIC"],
  urlPattern: /buxton\.com\.au\/property\/\d+\/[a-z0-9-]+\/?$/i,
  sourceType: "agency",
};
